// Import client configuration to get theme dynamically
import { CLIENT_CONFIG } from '../../client-config'

export type ColourSet = {
    primary: string
    secondary: string
    tertiary: string
}

export type FontColours = ColourSet & {
    black: string
    grey: string
    green: string
    green_accent: string
    blue: string
    blue_light: string
    blue_accent: string
    red: string
    red_accent: string
    light_grey: string
    dark_grey: string
    white_accent: string
    white_accent_dark: string
}

export type BackgroundColours = ColourSet & {
    blue: string
    red: string
    transparent_black: string
    dark_blue: string
    grey: string
    green_accent: string
    blue_accent: string
    white_accent: string
}

export type BorderColours = ColourSet & {
    grey: string
}

export type WisesheetsTheme = {
    colours: {
        font: FontColours
        background: BackgroundColours
        border: BorderColours
    }
}

// Export the theme from client configuration
export const wisesheetsTheme: WisesheetsTheme = CLIENT_CONFIG.theme
